import { useState } from "react";
import { withRouter } from "react-router-dom";
import '../assets/css/partnerProgram.scss';
import Card from "../models/common/Card";


function CardsFormatOne(props) {

    const [eyeBrownHeader] = useState(props.eyeBrownHeader);
    const [title] = useState(props.title);
    const [subTitle] = useState(props.subTitle);
    const [cards] = useState<Record<number, Card[]>>(props.cards);

    function createRows() {
        let htmlList: JSX.Element[] = [];
        for (const key in cards) {
            console.log(cards[key]);
            htmlList[key] = fillRow(cards[key]);
        }
        return htmlList;
    }

    function fillRow(cardsList: Card[]) {
        return <div className="rowCard justify-content-center ">
            {cardsList.map(c =>
                <div className="cardSection">
                    <img src={c.image} alt='...'width={c.imageWidth ? c.imageWidth : ""} />
                    {addTittle(c)}
                    <div className="cardText mt-2">{c.subTitle}</div>
                </div>)}

        </div>
    }

    function addTittle(card: Card) {
        return card.title === "" ? "" : <div className="cardTitle mt-2">{card.title}</div>;
    }


    return (

        <div>
            <div className="mb-5">
                <div className="benefLetterSection">
                    <div className="benefEyebrowHeader">
                        {eyeBrownHeader}
                    </div>
                    <div>{title}</div>
                    <div className="mt-3 benefHeaderTwo">
                        {subTitle}
                    </div>
                </div>
            </div>

            <div>
                {createRows()}
            </div>
        </div>

    )


}

export default withRouter(CardsFormatOne);



